import script from "./HeaderMuco60.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMuco60.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMuco60.vue?vue&type=style&index=0&id=2d49af44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d49af44"]])

export default __exports__